import { render } from "./orderMenuBox.vue?vue&type=template&id=5e15f1dd"
import script from "./orderMenuBox.vue?vue&type=script&lang=js"
export * from "./orderMenuBox.vue?vue&type=script&lang=js"

import "./orderMenuBox.vue?vue&type=style&index=0&id=5e15f1dd&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__